import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFontSettings } from '../hooks/useFontSettings';
import { FontSizeSelector } from './FontSizeSelector';
import { FontFamilySelector } from './FontFamilySelector';
import {
  FontLabel
} from '../DocumentSettingsTab.styles';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const SharedFontControls = ({ CurrentDesign, fontListVisible, onFontToggle, onFontToogle, LabelComponent = FontLabel, ...props }) => {
  const { t } = useTranslation(NAMESPACES);
  const { fontFamily, fontSize, onSizeChange, changeFontFamily, handleKeypress, handleKeyDown, handlePaste, inputRef } = useFontSettings(CurrentDesign);
  const handleFontToggle = onFontToggle || onFontToogle;

  return (
    <>
      <div className='doc-settings-grouping'>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, margin: '5px 0px 5px 0' }}>
          <LabelComponent className="fontSelection" style={{ marginBottom: '8px' }}>{t(DESIGN_AREA_SETTINGS_TAB.FONT_FAMILY.key, DESIGN_AREA_SETTINGS_TAB.FONT_FAMILY.value)}</LabelComponent>
        <FontFamilySelector
          fontFamily={fontFamily}
          onFontToggle={handleFontToggle}
          changeFontFamily={changeFontFamily}
          fontListVisible={fontListVisible}
          CurrentDesign={CurrentDesign}
        />
        </div>
        <div className='font-size-style' style={{ display: 'flex', flexDirection: 'column' }}>
          <LabelComponent className="fontSelection" style={{ marginBottom: '8px' }}>{t(DESIGN_AREA_SETTINGS_TAB.FONT_SIZE.key, DESIGN_AREA_SETTINGS_TAB.FONT_SIZE.value)}</LabelComponent>
          <FontSizeSelector
            fontSize={fontSize}
            onSizeChange={onSizeChange}
            inputRef={inputRef}
            handleKeypress={handleKeypress}
            handleKeyDown={handleKeyDown}
            handlePaste={handlePaste}
          />
        </div>
      </div>
    </>
  );
};

